import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { Page } from '../model/Page';
import { CallCenterSearchModel } from '../model/CallCenterSearchModel';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CallCenterViewModel } from '../model/CallCenterViewModel';

@Injectable({
  providedIn: 'root'
})
export class CallCenterService {
   
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }
  
  fetchFilterList(page: number, size: number, filterText: string) {
    let reqParams = `?page=${page}&size=${size}` + (filterText ? `&filterText=${filterText}` : '');
    return this.httpClient.get<Page<CallCenterSearchModel>>(ApiUrls.callCenterSearch + reqParams);
  }

  fetchCallCenterView(registrationId: number) {
    return this.httpClient.get<CallCenterViewModel>(
      ApiUrls.callCenterView.replace('{registrationId}', registrationId.toString()));
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}
